import { DataBean } from "../DataBean";

export class AddPayment extends DataBean {


    public async addPaymentAccountToPaymentTurn(year:any,idDocument:any,documentDate:any,code:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_addPaymentAccountToPaymentTurn_Number_Number_java.util.Date_Number_Number", [year,idDocument,documentDate,code,idEmployee]);
    }

}